// extracted by mini-css-extract-plugin
export var backdropBlur = "_80-0";
export var body = "_80-5";
export var bodyScroll = "_80-6";
export var columnFooter = "_80-7";
export var columnFooterFlush = "_80-8";
export var contentColumn = "_80-4";
export var frame = "_80-3";
export var heroContent = "_80-c";
export var heroOverlay = "_80-b";
export var image = "_80-a";
export var imageWrapper = "_80-9";
export var modal = "_80-1";
export var modalMain = "_80-2";
export var productHeader = "_80-d";
export var productHeaderIcon = "_80-e";
export var productHeaderName = "_80-f";
export var progressIndicator = "_80-g";